export default __webpack_public_path__ + "static/media/userUploadIcon.1f65ca4e.svg";